import React, { useMemo } from 'react';
import { FormControlContext } from './FormControlContext';
import { FormControlContextType } from './types';

interface Props extends FormControlContextType {
  children?: React.ReactNode;
}

/**
 * A component that can be used to provide form control to other components in the
 * component tree.
 */
export const FormControlProvider = ({ setValue, children }: Props) => {
  const contextValue = useMemo(() => ({ setValue }), [setValue]);
  return <FormControlContext.Provider value={contextValue}>{children}</FormControlContext.Provider>;
};
